import { StyledEspaco } from "./styles"

export default function Espaco(){
    return (
        <StyledEspaco></StyledEspaco>
    )
}